export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10457.7fe927db.jpg";